/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "8.0.0";
